var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetPasswordSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 0 64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4276 99.9548H42.7138C40.668 99.9548 38.7059 99.1467 37.2593 97.7082C35.8127 96.2698 35 94.3188 35 92.2846V61.6038C35 59.5695 35.8127 57.6186 37.2593 56.1801C38.7059 54.7417 40.668 53.9336 42.7138 53.9336H83.8539C85.8998 53.9336 87.8618 54.7417 89.3084 56.1801C90.755 57.6186 91.5677 59.5695 91.5677 61.6038V92.2846C91.5677 94.3188 90.755 96.2698 89.3084 97.7082C87.8618 99.1467 85.8998 99.9548 83.8539 99.9548H50.4276Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8753 77.4108L83.0551 68.0477C83.5601 67.5834 83.862 66.9355 83.8943 66.2463C83.9267 65.5571 83.6868 64.8831 83.2275 64.3727C82.7682 63.8622 82.1271 63.5571 81.4452 63.5244C80.7633 63.4917 80.0965 63.7342 79.5915 64.1984L66.7844 75.9803C65.8343 76.8548 64.5955 77.3395 63.3104 77.3395C62.0254 77.3395 60.7866 76.8548 59.8365 75.9803L47.0294 64.201C46.5244 63.7368 45.8576 63.4943 45.1757 63.527C44.4938 63.5597 43.8527 63.8648 43.3934 64.3753C42.9341 64.8857 42.6942 65.5597 42.7265 66.2489C42.7589 66.9381 43.0608 67.5861 43.5658 68.0503L53.7482 77.4134L43.5684 86.7505C43.3071 86.9769 43.0934 87.2539 42.94 87.5652C42.7865 87.8765 42.6964 88.2158 42.6749 88.5629C42.6535 88.91 42.7011 89.258 42.815 89.5861C42.929 89.9143 43.1069 90.2161 43.3382 90.4736C43.5695 90.7311 43.8496 90.939 44.1619 91.0852C44.4741 91.2313 44.8122 91.3127 45.1561 91.3245C45.5 91.3362 45.8428 91.2782 46.1641 91.1537C46.4854 91.0292 46.7788 90.8409 47.0268 90.5998L57.6879 80.8205C59.3527 81.9431 61.3091 82.5423 63.3104 82.5423C65.3118 82.5423 67.2682 81.9431 68.933 80.8205L79.5941 90.5998C80.1025 91.0404 80.7609 91.2632 81.4294 91.221C82.0978 91.1788 82.7236 90.8748 83.1739 90.3737C83.6241 89.8726 83.8633 89.2137 83.8407 88.5372C83.818 87.8607 83.5353 87.2197 83.0525 86.7505L72.8753 77.4108Z",
    fill: "#EEF5FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.267 56.2431L52.2503 63.4151L54.8832 52.5598L60.267 56.2431Z",
    fill: "#C7CCD0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9324 41.2092L91.8955 29.0004L65.7278 60.6469L38.9324 41.2092Z",
    fill: "#EEF5FD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.526 30.018L50.2586 49.4586L52.2396 63.4165L55.4265 52.0992L89.526 30.018Z",
    fill: "#D7E2F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 64,
    y1: 0,
    x2: 64,
    y2: 128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 63.2839,
    y1: 53.9336,
    x2: 63.2839,
    y2: 99.9548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FF8265"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF015E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPasswordSuccess);
export default __webpack_public_path__ + "static/media/reset-password-success.ddb5f696cece240244306a5852223c9a.svg";
export { ForwardRef as ReactComponent };